import { TRANSPORT } from '../../service/enums.js';
import { removeUndefined } from '../../utils/objects.js';
import { BaseWrapperField, } from './BaseWrapperField.js';
import createField from './createField.js';
class RecordField extends BaseWrapperField {
    minProperties;
    maxProperties;
    propertyNamesPattern;
    constructor(data) {
        super({ ...data, items: createField(data.items) });
        this.minProperties = data.minProperties;
        this.maxProperties = data.maxProperties;
        this.propertyNamesPattern = data.propertyNamesPattern;
        this.proto.type = `map<string, ${this.innerType}>`;
    }
    toSchema(transport, options) {
        let itemsSchema = this.items.toSchema(transport);
        if (transport === TRANSPORT.GRPC && this.dimensions > 1 && itemsSchema) {
            itemsSchema = {
                type: 'object',
                properties: {
                    [BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME]: itemsSchema,
                },
                required: [BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME],
            };
        }
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: 'object',
            minProperties: this.minProperties,
            maxProperties: this.maxProperties,
            ...(this.propertyNamesPattern && {
                propertyNames: {
                    pattern: this.propertyNamesPattern,
                },
            }),
            properties: {},
            additionalProperties: itemsSchema,
        });
    }
    toJSON(input, target) {
        return Object.entries(input).reduce((map, [key, value]) => {
            const serializedValue = this.items.toJSON(value, target);
            if (target === TRANSPORT.GRPC && this.dimensions > 1) {
                map[key] = {
                    [BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME]: serializedValue,
                };
            }
            else {
                map[key] = serializedValue;
            }
            return map;
        }, {});
    }
    fromJSON(input) {
        if (!input) {
            return input;
        }
        return Object.entries(input).reduce((map, [key, value]) => {
            map[key] = this.items.fromJSON(value);
            return map;
        }, {});
    }
    fromProto(input) {
        if (!input) {
            return input;
        }
        return Object.entries(input).reduce((map, [key, value]) => {
            map[key] = this.items.fromProto(this.dimensions > 1
                ? value[BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME]
                : value);
            return map;
        }, {});
    }
}
export default RecordField;
//# sourceMappingURL=RecordField.js.map